import { getDurationAndPerformOnFrame } from "@elastic/eui";
import moment from "moment";
import React, { useState, useEffect, useImperativeHandle, forwardRef, useMemo, useCallback } from "react";
import FlexView from "react-flexview";
import DataGrid from "../../../../../shared/components/Grid";
import {exportGrid, initialColsSelector, onChangeColumns} from "../../../../../shared/components/Grid/functions";
import { resetFilters } from "../../../../../shared/components/Grid/functions/filters";
import { ToSQL } from "../../../../../shared/utils/fecha";
import { useApiGrid } from "./apiHook";
import { getColumnDefs } from "./columnDefs";
import { useLanguage } from "../../../../../shared/hooks/Language";
import { useUserSettings } from "../../../context/CurrentUserContext";

export interface Props {
  data: any;
  selected:any;
  type?: string;
  style?: any;
  menu: boolean;
  selector: boolean;
  onSelected(selected: any): any;
  externalFilter:any;
}

export const GridResultsScreen = forwardRef((props:Props, ref:any) => {

  const {api,setApis,columnApi,rowApi} = useApiGrid();
  const {translate}=useLanguage();
  const {currentUser}=useUserSettings();

  let { data, style, menu, selector, onSelected, type,selected,externalFilter} = props;
  let columnDefs = getColumnDefs(translate,currentUser);
  let [columnsState, SetColumnsState] = useState(selector?initialColsSelector(columnDefs):[])

  useEffect(()=>{
    if(api!==undefined){
      api.onFilterChanged()
    }
  },[externalFilter,api])

  const onSelection = (api: any, selected: any) => {
		onSelected && onSelected(selected);
  };

  const onRowValueChanged = (api: any, event: any) => {};
  
  const onHideColumn = (newColumns:[any]) =>{
    let newState = onChangeColumns(newColumns, columnDefs);
    SetColumnsState(newState)
  }

  const onfilterChanged =()=>{onSelected(undefined)}

  const customExport = ['nombre','dni','direccionNegocio','idCP','codArea','area','perfil','login','email','nombreResponsable','expatriado','masCincuentaPorc','controlUsuarios','tipo']

  useImperativeHandle(
    ref,
    () => ({
        onFilterClear(){
          api && resetFilters(api)
        },
        onExport() {
          exportGrid({ fileName: "Usuarios", api: api, columnKeys: customExport })
      }
    })
  )

  const updateApi = (apiUpdate:any, columnApiUpdate:any) =>{
    setApis(apiUpdate,columnApiUpdate)
  }

  const isExternalFilterPresent = () => {
    return true;
  };

  const esExpatriado = (fechaExpatriadoDesde:any, fechaExpatriadoHasta:any) => fechaExpatriadoDesde!==null && 
    ((moment(ToSQL(moment(fechaExpatriadoHasta),'-')).isSameOrAfter(ToSQL(moment(Date.now()),'-'))) || fechaExpatriadoHasta===null)


  const expatriadoFacturable = (dataRow:any) => (
    //dataRow.expatriado===true && (dataRow.fechaExpatriadoDesde!==null && dataRow.fechaFacturacionExpatriadoInicial!==null && dataRow.empresaExpatriado!==null)
  dataRow.empresaExpatriado!==null && dataRow.fechaFacturacionExpatriadoInicial!==null && 
  (dataRow.fechaFacturacionExpatriadoFinal===null || 
    ((moment(ToSQL(moment(dataRow.fechaFacturacionExpatriadoFinal),'-')).isSameOrAfter(ToSQL(moment(Date.now()),'-'),'month'))))
  )
  
  const expatriadoNofacturable = (dataRow:any) =>(//dataRow.expatriado===true && 
    dataRow.fechaExpatriadoDesde !== null  &&
    (dataRow.fechaFacturacionExpatriadoInicial===null || (dataRow.fechaExpatriadoHasta !== null  && dataRow.fechaFacturacionExpatriadoInicial===null) || dataRow.empresaExpatriado===null)

  //   ((dataRow.fechaExpatriadoDesde!==null && dataRow.fechaFacturacionExpatriadoInicial===null && dataRow.fechaFacturacionExpatriadoFinal===null))
  // || (dataRow.fechaExpatriadoDesde!==null && dataRow.fechaFacturacionExpatriadoInicial!==null && dataRow.empresaExpatriado===null)
  )
  
  const noExpatriado = (dataRow:any) => {
    //|| dataRow.expatriado===false
  return (esExpatriado(dataRow.fechaExpatriadoDesde,dataRow.fechaExpatriadoHasta) === true ? false : true)
  }
    // || 
    // (dataRow.fechaExpatriadoDesde===undefined || dataRow.fechaExpatriadoDesde===null) && 
    // (dataRow.fechaExpatriadoHasta===undefined || dataRow.fechaExpatriadoHasta===null))

  const doesExternalFilter = (dataNode:any,externalFilterPass:any) => {
    if(externalFilterPass!==undefined && externalFilterPass.todos===false)
    {
      let isDataFilter:boolean = false;

      if(externalFilterPass.noExpatriados===true && isDataFilter===false)
      isDataFilter = noExpatriado(dataNode)
      if(externalFilterPass.expatriadosNoFacturables===true && isDataFilter===false)
      isDataFilter = expatriadoNofacturable(dataNode)
      if(externalFilterPass.expatriadosFacturables===true && isDataFilter===false)
      isDataFilter = expatriadoFacturable(dataNode)

      return isDataFilter;
    }
    else
    return true;
  }

  const rowClassRules = {
    'selectionWarning': (params:any) => !noExpatriado(params.data) && expatriadoNofacturable(params.data),
    'selectionSuccess': (params:any) => !noExpatriado(params.data) && expatriadoFacturable(params.data)
  }

    return (
      <FlexView grow column>
        <DataGrid
        data={data}
        autosize={true}
        //immutableData={true}
        columnDefs={columnDefs}
        columnsState={columnsState}
        menu={menu}
        selector={selector}
        floatingFilter
        fileExportName="usuarios"
        onHideColumn = {onHideColumn}
        onSelectionChanged={onSelection}
        onRowValueChanged={onRowValueChanged}
        onFilterChanged={onfilterChanged}
        updateApi={updateApi}
        isExternalFilterPresent={isExternalFilterPresent}
        doesExternalFilterPass={doesExternalFilter}
        externalFilter={externalFilter}
        rowClassRules={rowClassRules}
        translate={translate}
        />
      </FlexView>
    );
})